import React, { Component } from "react";
import { Button, Spin } from "antd";
// 引入样式
import "./index.styl";
// 接口
// 图片
import errorStuts from "@/assets/img/stationTobu/errorStuts.png";
import normalStuts from "@/assets/img/stationTobu/normalStuts.png";
import powerboxIcon from "@/assets/img/stationTobu/powerboxIcon.png";
import powerboxLenged from "@/assets/img/stationTobu/powerboxLenged.png";
import stationIcon from "@/assets/img/stationTobu/stationIcon.png";
import stationLenged from "@/assets/img/stationTobu/stationLenged.png";
import stubIcon from "@/assets/img/stationTobu/stubIcon.png";
import stubItemErrorIcon from "@/assets/img/stationTobu/stubItemErrorIcon.png";
import stubItemIcon from "@/assets/img/stationTobu/stubItemIcon.png";
import stubItemLenged from "@/assets/img/stationTobu/stubItemLenged.png";
import stubLenged from "@/assets/img/stationTobu/stubLenged.png";
import more from "@/assets/img/stationTobu/more.png";
import nodata from "@/assets/img/stationTobu/nodata.png";
import { injectIntl } from "react-intl";
import fetchHandler from "../../../fetch/fetchHandler";
import {
  getStubInfoList,
  stubGroupRelation,
} from "../../../fetch/fetchApi";

class StubGroupTobu extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    // 设置电站id
    this.queryStubGroupName = "";
    this.queryStubGroupId = "";
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryStubGroupName = window.LayoutTab.tabParam.stubGroupName ? window.LayoutTab.tabParam.stubGroupName : "";
      this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId ? window.LayoutTab.tabParam.stubGroupId : "";
    }
    this.state = {
      showMore: false,
      nodata: false,
      spinning: true,
      stubItems: [{
        id: "103011220",
        stuats: 0,
      }, {
        id: "103011220",
        stuats: 1,
      }, {
        id: "103011220",
        stuats: 1,
      }, {
        id: "103011220",
        stuats: 1,
      }],
      stubGroup: ["123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123", "123"],
      powerBoxList: [123, 123, 123, 123, 123, 123],
      stationInfo: {},
      powerBoxLength: 0,
      stubListLenght: 0,
      stubItemNUm: 0,
    };
    this.getTobuData();
  }

    // 获取所有枪数量
    getStubItemNum = () => {
      fetchHandler(getStubInfoList, {
        stubGroupId: this.queryStubGroupId,
      }).then((res) => {
        if (res && (res.code === "success" || res.code === "ok")) {
          this.setState({
            stubItemNUm: res.data.length,
          });
        }
      });
    }

    // 获取拓扑图数据
    getTobuData = () => {
      fetchHandler(stubGroupRelation, {
        stubGroupId: this.queryStubGroupId,
      }).then((res) => {
        if (res && res.code === "success") {
          // 循环获取
          let stubL = 0;
          if (res.data.powerBoxRelationDTOList) {
            res.data.powerBoxRelationDTOList.map((powerBox) => {
              if (powerBox.equipmentQuantity) {
                stubL += powerBox.equipmentQuantity;
              }
              return true;
            });
          }
          this.setState({
            nodata: !res.data.powerBoxRelationDTOList,
          }, () => {
            this.setState({
              spinning: false,
              stationInfo: res.data,
              powerBoxLength: res.data.powerBoxRelationDTOList
                ? res.data.powerBoxRelationDTOList.length : 0,
              stubListLenght: stubL,
            });
          });
        } else {
          this.setState({
            nodata: true,
            spinning: false,
          });
        }
      });
    }

    // 00：空闲，01：充电中，02XX：故障，03：车位占用，04：维护中，06：在建中，05：离线，07： 桩程序升级，08：预约等待充电中，09：储能车储能中，10：离线充电中
    renderStub = (stub, index, stubLength) => {
      let className = "";
      if (index === 0) {
        className = "left-shu-3 first";
      } else if (index === stubLength - 1) {
        className = "left-shu-3 last";
      } else {
        className = "left-shu-3";
      }
      return stub.stubGroupId !== "beta" ? (
        <div className="stub-item-item" onClick={() => { this.gotoStubListPage(stub.id); }}>
          {
              stubLength > 1 && <div className={className}></div>
          }
          <div className="stub-pic">
            <div className="info">
              <div className="left-heng1"></div>
              <img alt="" className="stubItemIcon" src={(stub.status === "02" || stub.status === "05" || stub.status === "04") ? stubItemErrorIcon : stubItemIcon} />
            </div>
            <div className="stuts">
              <img alt="" className="stuats-icon" src={(stub.status === "02" || stub.status === "05" || stub.status === "04") ? errorStuts : normalStuts} />
              <div className="stub-items-id" title={stub.id}>{stub.id}</div>
            </div>
          </div>
        </div>) : null;
    }

    renderStubGroup = (stub, index, stubLength) => {
      if (stubLength > 20 && !this.state.showMore) {
        this.setState({
          showMore: true,
        });
      }
      // 判断非bata桩的个数
      const betaList = [];
      if (stub.stubRelationDTOList) {
        stub.stubRelationDTOList.map((stub2) => {
          if (stub2.stubGroupId !== "beta") {
            betaList.push(stub2);
          }
          return null;
        });
      }
      let className = "";
      if (index === 20 || index === stubLength - 1) {
        className = "left-shu-1 last";
      } else if (index === 0) {
        className = "left-shu-1 first";
      } else {
        className = "left-shu-1";
      }
      return index <= 20 ? (
        <div className="stub-item">
          <div className={className}></div>
          <div className="left-arrow"></div>
          <div
            className="stub-info"
            onClick={() => {
              if (index < 20) {
                this.gotoStubListPage(stub.id);
              }
            }}>
            {
                index < 20 ? <img alt="" className="stubIcon" src={stubIcon} /> : null
            }
            {
                index < 20 ? <div className="stubId" title={stub}>{stub.id}</div> : null
            }{
                index === 20 ? <img alt="" title="关联设备超过20个" style={{ width: 5, marginLeft: 40 }} src={more} /> : ""
            }
          </div>
          {
                (index < 20 && stub.stubRelationDTOList && stub.stubRelationDTOList.length > 0 && betaList.length > 0) && <div className="right-arrow"></div>
            }
          {
                index < 20 ? (
                  <div className="stub-items-group">
                    {
                        stub.stubRelationDTOList
                          ? stub.stubRelationDTOList.map(
                            (stub2, index2) => this.renderStub(stub2, index2,
                              stub.stubRelationDTOList.length),
                          )
                          : null
                    }
                  </div>) : null
            }
        </div>
      ) : null;
    }

    renderPowerBox = (powerbox, index, powerBoxList) => {
      let className = "";
      if (index === 0) {
        className = "powerbox-heng first";
      } else if (index === powerBoxList - 1) {
        className = "powerbox-heng last";
      } else {
        className = "powerbox-heng";
      }
      return (
        <div className="item-info-group">
          {
              powerBoxList > 1
                ? <div className={className}></div>
                : null

          }
          {
              powerBoxList > 1 && <div className="powerbox-shu"></div>
          }
          <div className="powerbox-info" onClick={() => { this.gotoPowerboxPage(powerbox.meterModuleId); }}>
            <img alt="" className="power-box-icon" src={powerboxIcon} /> {powerbox.meterModuleId}
          </div>
          {
                    powerbox.equipmentRelationDTOList && <div className="powerbox-shu-2"></div>
                }
          <div className="stub-group">
            {
                        powerbox.equipmentRelationDTOList
                          ? powerbox.equipmentRelationDTOList.map(
                            (stubs, index2) => this.renderStubGroup(stubs,
                              index2, powerbox.equipmentRelationDTOList.length),
                          )
                          : null
                    }
          </div>
        </div>
      );
    }

    // 跳转设备快速查询
    gotoPage = () => {
      this.props.onAdd({
        key: "0102",
        titleText: "设备快速查询",
      }, {
        StubName: this.queryStubGroupName,
        stubGroupId: this.queryStubGroupId,
      });
    }

    // 跳转电站列表
    gotoStationPage = () => {
      this.props.onAdd({
        key: "0101",
        titleText: "电站列表",
      }, {
        stubGroupName: this.queryStubGroupName,
        stubGroupId: this.queryStubGroupId,
      });
    }

    // 跳转配电柜列表
    gotoPowerboxPage = (key) => {
      this.props.onAdd({
        key: "0104",
        titleText: "配电柜管理",
      }, {
        meterModuleId: key,
      });
    }

    // 跳转配电柜列表
    gotoStubListPage = (key) => {
      this.props.onAdd({
        key: "0102",
        titleText: "设备快速查询",
      }, {
        stubId: key,
      });
    }

    render = () => {
      const content = (
        <div className="display-board-page station-tobu-page">
          <div className="page-title-bar">
            <div className="title">电站结构拓扑图</div>
            <div className="lenged">
              <div className="lengen-item"><img alt="" className="lenged-icon" src={stationLenged} />充电站</div>
              <div className="lengen-item"><img alt="" className="lenged-icon" src={powerboxLenged} />配电柜</div>
              <div className="lengen-item"><img alt="" className="lenged-icon" src={stubLenged} />充电桩</div>
              <div className="lengen-item"><img alt="" className="lenged-icon" src={stubItemLenged} />充电枪</div>
            </div>
          </div>
          {
                !this.state.nodata
                  ? (
                    <div className="tobu-content">
                      <Spin spinning={this.state.spinning}>
                        <div className="tobu-squire station-name">
                          <div className="line-name">充电站</div>
                          <div className="inner-part has-border" onClick={() => { this.gotoStationPage(); }}>
                            <img alt="" className="icon-station" src={stationIcon} />{this.queryStubGroupName}
                          </div>
                          <div className="shu"></div>
                        </div>
                        <div className="scroll-content">
                          <div className="tobu-squire powerbox" style={{ width: this.state.stationInfo.powerBoxRelationDTOList ? this.state.stationInfo.powerBoxRelationDTOList.length * 360 : "100%", minWidth: "100%" }}>
                            <div className="line-name">配电柜({this.state.powerBoxLength})</div>
                            <div className="line-name top-2">充电桩({this.state.stubListLenght})</div>
                            {
                                this.state.stationInfo.powerBoxRelationDTOList
                                  ? this.state.stationInfo.powerBoxRelationDTOList.map(
                                    (powerbox, index) => this.renderPowerBox(powerbox, index,
                                      this.state.stationInfo.powerBoxRelationDTOList.length),
                                  )
                                  : null
                            }
                          </div>
                          {
                            this.state.showMore && <div className="show-more-btn"><Button onClick={() => { this.gotoPage(); }} type="primary">更多数据请查看详情</Button></div>
                        }
                        </div>
                      </Spin>
                    </div>)
                  : null
            }
          {
                this.state.nodata
                  ? (
                    <div className="no-data">
                      <img alt="" src={nodata} />
                      <div className="nodata-wz">暂时没有数据～</div>
                    </div>)
                  : null
            }
        </div>);
      return content;
    }
}

export default injectIntl(StubGroupTobu);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stubGroup/stubGroupTobu.js